import { ScreenComponentMap, ScreenType } from '../../types';
import { CallInsightScreen } from './call-insight-screen';
import { CallPathMappingScreen } from './call-path-mapping-screen';
import { CallQualityDrilldownScreen } from './call-quality-drilldown-screen';
import { CallQualityScreen } from './call-quality-screen';

export const Screens: ScreenComponentMap = {
  [ScreenType.CALL_INSIGHTS]: CallInsightScreen,
  [ScreenType.CALL_QUALITY]: CallQualityScreen,
  [ScreenType.CALL_QUALITY_DRILLDOWN]: CallQualityDrilldownScreen,
  [ScreenType.CALL_PATH_MAPPING]: CallPathMappingScreen,
};
